import React, { ReactElement } from 'react';
import Table from '../../../../../../components/table/table.component';
import TableBody from '../../../../../../components/table-body/table-body.component';
import TableRow from '../../../../../../components/table-row/table-row.component';
import TableCell from '../../../../../../components/table-cell/table-cell.component';
import FormFieldCheckbox from '../../../../../../components/form-field-checkbox/form-field-checkbox.component';
import SinglePageTab from '../../../../../app/common/single-page-tab/single-page-tab.component';
import FormatService from '../../../../../../services/format-service';

const SettingsUserInternalComments: ReactMemoComponent = React.memo((
  props: ReactComponentProps,
): ReactElement => {
  const {
    isSaving,
    isSaveDisabled,
    isEditMode,
    isRightDrawerOpen,
    formError,
    commentTypeSettingsData,
    onCancelForm,
    onSubmitForm,
  } = props;

  const formPrefix: string = 'commentTypeSettings';

  return (
    <SinglePageTab
      isSaving={isSaving}
      isSaveDisabled={isSaveDisabled}
      isEditMode={isEditMode}
      isRightDrawerOpen={isRightDrawerOpen}
      isEmpty={!commentTypeSettingsData || !commentTypeSettingsData.length}
      formError={formError}
      onCancelForm={onCancelForm}
      onSubmitForm={onSubmitForm}
    >
      <Table>
        <TableBody isPlain withNoBorders withTwoColumns withHeaderColumn>
          {
            commentTypeSettingsData && !!commentTypeSettingsData.length
            && commentTypeSettingsData.map((settingItem: Setting): ReactElement => (
              <TableRow key={settingItem.id}>
                <TableCell>
                  {settingItem.title}
                </TableCell>
                <TableCell>
                  {
                    isEditMode ? (
                      <FormFieldCheckbox
                        withNoLabelOffset
                        name={`${formPrefix}[${settingItem.name}].value`}
                      />
                    ) : (
                      FormatService.formatBooleanValue(settingItem.value)
                    )
                  }
                </TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </SinglePageTab>
  );
});

export default SettingsUserInternalComments;
